module.exports = __webpack_public_path__ + "static/media/5.3d1a8c52.jpg";